import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { AuthResponse } from '@shared/types/api'

interface AuthState {
  user: AuthResponse | null
  setAuth: (user: AuthResponse) => void
  clearAuth: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      setAuth: (user) => set({ user }),
      clearAuth: () => set({ user: null }),
    }),
    { name: 'cp-auth' }
  )
)
